export default function GroupItem(node, { addClass = (className) => node.classList.add(className), removeClass = (className) => node.classList.remove(className), } = {}) {
    addClass('smui-button__group-item');
    return {
        destroy() {
            removeClass('smui-button__group-item');
        },
    };
}
//# sourceMappingURL=GroupItem.js.map